module.exports = __webpack_public_path__ + "static/media/location.743cd1c9.svg";